<template>
  <div>
    <div class="container-fluid work" id="work">
      <div class="row img-row">
        <div class="img-col col-lg-3 col-md-6 col-sm-6 col-xs-12" v-for="(project, key) in projects" :key="key">
          <imageBlock :project="project"></imageBlock>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imageBlock from '../../src/pages/components/imageBlock';
import axios from 'axios';
import { EventBus } from '../../src/pages/components/eventBus.js';
// import data from '../../public/data.json';

export default {
  components: {
    imageBlock: imageBlock
  },
  name: "work",
  data() {
    return {
      currentOrder: 'id',
      totalProjects: [],
      projects: [],
      lang: 'en',
      img: process.env.VUE_APP_PUBLIC + '/img/bg_footer.jpg',
      totalShow: 4,
      loaded: false,
      counter: 0
    }
  },
  methods: {
    loadProjects() {
      var self = this;
      axios.get(process.env.VUE_APP_PUBLIC + '/data.json')
        .then(function (response) {
          self.totalProjects = response.data;
          self.totalProjects = self.totalProjects.slice().reverse();
          self.getProjects();
        }).catch(function (error) {
          return error;
        });
    },
    callProjects(sPos, ePos) {
      for (var i = sPos; i < ePos; i++) {
        if(this.totalProjects[i] !== undefined) {
          this.projects.push(this.totalProjects[i]);
        }
      }
    },
    getProjects() {
      this.callProjects(0,this.totalShow);
      EventBus.$on('workHeight', val => {
        if(val < window.innerHeight) {
          this.callProjects(this.totalShow,this.totalShow + 4);
          this.totalShow = this.totalShow + 4;
        }
      });
    },
    scroll() {
      window.onscroll = () => {
        let bottomWindow = document.documentElement.scrollTop + window.innerHeight;
        let bottomWork = 0;
        if(document.getElementById("work")) {
          bottomWork = document.getElementById("work").offsetHeight;
        }
        let crossBottom = bottomWindow >= bottomWork;

        if(crossBottom == false) {
          this.counter = 0;
        }

        if (crossBottom) {
          if(this.counter === 0) {
            this.callProjects(this.totalShow,this.totalShow + 4);
          }
          this.totalShow = this.totalShow + 4;
          this.counter = 1;
        }
      };
    }
  },
  mounted() {
    this.loadProjects();
    this.scroll();
    EventBus.$on('lang', lang => {
      this.lang = lang;
    });
    this.lang = this.$cookie.get('pixel-deep.com');
  }
}

</script>

<style lang="scss">
    .btn-outline {
        margin: 30px auto;
        border: 1px solid rgba(#fff, 0.2);
        padding: 10px 35px;
        border-radius: 0;
        color: #fff;
        font-size: 13px;
        transition: all 0.3s;

        &:hover {
            transition: all 0.3s;
            padding: 15px 40px;
        }
    }

    .load-more-btn {
        padding: 0;
        margin: 0;
        width: 100%;
        background: darken(#AD1C56, 30%);
    }
</style>
